<div class="flex-fill d-flex flex-column">
  <div class="d-flex mx-2 my-3" style="gap: 15px">
    <div class="d-flex flex-column">
      @if (uow.hasChanges()) {
        <div class="d-flex m-1" style="gap: 5px">
          <button class="btn btn-primary" (click)="save()">Save</button>
          <button class="btn btn-danger" (click)="cancel()">Cancel</button>
        </div>
      }
      <dx-select-box [(value)]="table" [items]="tables" [searchEnabled]="true" (onValueChanged)="selectionChanged()" class="mt-auto"></dx-select-box>
    </div>
    <div class="d-flex flex-column flex-fill" style="max-width: 1100px">
      <dx-form [colCount]="3">
        <dxi-item itemType="group" caption="Invoice Email">
          <dxi-item [label]="{ text: 'Subject' }">
            <div *dxTemplate>
              @if (invoiceSubject) {
                <dx-text-box [(value)]="invoiceSubject.stringValue"></dx-text-box>
              }
            </div>
          </dxi-item>
          <dxi-item [label]="{ text: 'Body' }">
            <div *dxTemplate>
              @if (invoiceBody) {
                <dx-text-area [(value)]="invoiceBody.stringValue" [height]="125"></dx-text-area>
              }
            </div>
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" caption="Quote Email">
          <dxi-item [label]="{ text: 'Subject' }">
            <div *dxTemplate>
              @if (quoteSubject) {
                <dx-text-box [(value)]="quoteSubject.stringValue"></dx-text-box>
              }
            </div>
          </dxi-item>
          <dxi-item [label]="{ text: 'Body' }">
            <div *dxTemplate>
              @if (quoteBody) {
                <dx-text-area [(value)]="quoteBody.stringValue" [height]="125"></dx-text-area>
              }
            </div>
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" caption="Statement Email">
          <dxi-item [label]="{ text: 'Subject' }">
            <div *dxTemplate>
              @if (statementSubject) {
                <dx-text-box [(value)]="statementSubject.stringValue"></dx-text-box>
              }
            </div>
          </dxi-item>
          <dxi-item [label]="{ text: 'Body' }">
            <div *dxTemplate>
              @if (statementBody) {
                <dx-text-area [(value)]="statementBody.stringValue" [height]="125"></dx-text-area>
              }
            </div>
          </dxi-item>
        </dxi-item>
      </dx-form>
    </div>
  </div>
  <div class="m-1 grid-fill">
    <dx-data-grid #dataGrid [dataSource]="entities" keyExpr="id" (onCellDblClick)="rowDoubleClick($event)">
      <dxi-column dataField="name" width="350"></dxi-column>
      @if (table === 'Customer Tax Codes') {
        <dxi-column dataField="taxCode" width="100"></dxi-column>
      }
      @if (table === 'Customer Tax Codes') {
        <dxi-column dataField="isTaxable" width="100"></dxi-column>
      }
      @if (table === 'Product Units Of Measure') {
        <dxi-column dataField="abbreviation" width="100"></dxi-column>
      }
      @if (table === 'Product Units Of Measure') {
        <dxi-column dataField="weightBasedUnit" caption="Weight Based" width="110"></dxi-column>
      }
      @if (table === 'Product Units Of Measure') {
        <dxi-column dataField="volumeBasedUnit" caption="Volume Based" width="110"></dxi-column>
      }
      @if (table === 'Product Units Of Measure') {
        <dxi-column dataField="quantityBasedUnit" caption="Quantity Based" width="110"></dxi-column>
      }
      @if (table === 'Product Units Of Measure') {
        <dxi-column dataField="poundsMultiplier" width="125"></dxi-column>
      }
      @if (table === 'Product Categories') {
        <dxi-column dataField="description" width="200"></dxi-column>
      }
      @if (table === 'Product Categories') {
        <dxi-column dataField="isTaxable" width="100"></dxi-column>
      }
      @if (table === 'Product Locations') {
        <dxi-column dataField="scaleCode" width="200"></dxi-column>
      }
      @if (table === 'Product Locations') {
        <dxi-column dataField="trackInventory" width="125"></dxi-column>
      }
      <dxi-column dataField="displayOrder" width="300"></dxi-column>
      <dxi-column></dxi-column>

      <div *dxTemplate="let data of 'toolbarButtons'">
        <button
          (click)="openSelection(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || !table"
          class="btn btn-success ms-2"
          >
          Edit
        </button>
        <button type="button" (click)="openSelection()" [disabled]="!table" class="btn btn-secondary ms-2">New</button>
        <button
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || !table"
          (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
          class="ms-3 btn btn-danger"
          >
          Delete
        </button>
      </div>
      <dxo-row-dragging [allowReordering]="true" [onReorder]="onReorder" [showDragIcons]="false"></dxo-row-dragging>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (entities) {
          <span class="me-3">
            <strong>
              {{ dataGrid.instance.totalCount() + " items" }}
              {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
            </strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>
